import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';

@Injectable()
export class MaterialService {

    snackBarDurationInSeconds: number = 4;
    constructor(
        private snackBar: MatSnackBar,
    ) { }

    //openSnackBar(message: string, action: string = 'OK', duration: number = this.snackBarDurationInSeconds, extraCss: string = 'blueSnack') {
    openSnackBar(message: string = 'Message', extraCss: string = 'blueSnack', action: string = 'OK', duration: number = this.snackBarDurationInSeconds) {
        return this.snackBar.open(message, action, {
            duration: duration * 1000,
            panelClass: [extraCss]
        });
    }


}
